import { combineReducers } from 'redux'
import testing from './testing'

export default combineReducers({
  testing,
})

export * from './testing'
